export type Intent = 'success' | 'danger'

/**
 * Concrete styling kind: `Intent` plus a `'muted'` neutral state used when
 * there's no delta yet, no preference, or the control is disabled. Each
 * platform maps `IntentKind` to its own color/class via a record lookup.
 */
export type IntentKind = Intent | 'muted'

/** Collapses `Intent | undefined` to a concrete `IntentKind`. */
export const resolveIntent = (intent: Intent | undefined): IntentKind =>
  intent ?? 'muted'

/**
 * Maps a delta + directional preference to an `Intent` for visual styling.
 * `betterWhen: 'lower'` means a negative delta is good; `'higher'` flips.
 * Returns `undefined` when there's no delta or no preference (neutral).
 */
export const computeIntent = (
  delta: number | undefined,
  betterWhen: 'lower' | 'higher' | undefined
): Intent | undefined => {
  if (delta === undefined || betterWhen === undefined) return undefined
  const isBetter = betterWhen === 'lower' ? delta < 0 : delta > 0
  return isBetter ? 'success' : 'danger'
}
